import Api from '@/services/Api'

export default {
    getAllScorexByVigencia(vigencia){
        return Api().get('score/getAllScorexByVigencia/'+vigencia)
    },
    createScoreCifras(datos){
        return Api().post('score/createCifras',datos)
    },
    createScoreX(info){
        return Api().post('score/createX',info)
    },
}
